import React, { useEffect } from 'react';
import { Form, Input, Modal, Select } from 'antd';
import { LEAD_STATUS_REASONS, type LeadStatusReasonInput } from '@/services/lead.service';

interface Props {
  /** Lost or Unqualified; the modal is closed when null. */
  status: string | null;
  leadName?: string;
  confirmLoading?: boolean;
  onSubmit: (reason: LeadStatusReasonInput) => void;
  onCancel: () => void;
}

/** Asks why a lead is being marked Lost or Unqualified (the backend requires it). */
export const LeadStatusReasonModal: React.FC<Props> = ({ status, leadName, confirmLoading, onSubmit, onCancel }) => {
  const [form] = Form.useForm<{ status_reason: string; status_reason_notes?: string }>();

  useEffect(() => {
    if (status) form.resetFields();
  }, [status, form]);

  return (
    <Modal
      open={!!status}
      title={`Mark ${leadName ? `"${leadName}" ` : 'lead '}as ${status ?? ''}`}
      okText={`Mark ${status ?? ''}`}
      okButtonProps={{ danger: true }}
      confirmLoading={confirmLoading}
      onCancel={onCancel}
      onOk={async () => {
        const v = await form.validateFields();
        onSubmit({ status_reason: v.status_reason, status_reason_notes: v.status_reason_notes?.trim() || null });
      }}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item name="status_reason" label="Reason" rules={[{ required: true, message: 'Choose a reason' }]}>
          <Select options={LEAD_STATUS_REASONS.map((r) => ({ value: r, label: r }))} placeholder="Why?" />
        </Form.Item>
        <Form.Item noStyle shouldUpdate={(a, b) => a.status_reason !== b.status_reason}>
          {({ getFieldValue }) => (
            <Form.Item
              name="status_reason_notes"
              label="Details"
              rules={[{ required: getFieldValue('status_reason') === 'Other', message: 'Describe the reason' }]}
            >
              <Input.TextArea rows={3} placeholder="Competitor, budget, timing… (optional unless Other)" />
            </Form.Item>
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default LeadStatusReasonModal;
